module.exports = __webpack_public_path__ + "static/media/leaf_grey.9dde9aa9.png";